<template>
<v-divider ></v-divider>
</template>

<script>
/*
 * Not a real action. Used to place a divider in an action list
 */

export default {
	name: "JmRowActionDivider",
};

</script>



// WEBPACK FOOTER //
// src/components/widgets/RowActionWidgets/RowActionDivider.vue